import { combineReducers } from 'redux';
import { collection } from 'modules/adapter';
import { getFanVideosBase } from './actions';

export const fanVideosReducer = combineReducers({
  videos: collection(getFanVideosBase),
});
